<app-carousel>

  <ng-template carouselItem="1">
    <ng-container *ngTemplateOutlet="matDescriptionContent"></ng-container>
  </ng-template>

  <ng-template carouselItem="2" *ngIf="inventoryModule && resources.length > 0">
    <mat-card class="mat-card-c">
      <h2 style="display: flex; justify-content: center;"><strong>Recursos</strong></h2>
      <app-button-label [labelsEdit]="labels"></app-button-label>
      <data-table
        [title]="''"
        [columns]="columnsResouces"
        [configuration]="configurationResouces"
        [url]="urlGetTablaResourcesAuthorization"
        [params]="paramsResourcesAuthorization"
        (internalData)="dataResources($event)">
      </data-table>
    </mat-card>
  </ng-template>

    <ng-template carouselItem="3" >
    <mat-card class="mat-card-c">
      <data-table
        [title]="titleC"
        [columns]="columnsComments"
        [configuration]="configurationComments"
        [reloadTable]="reloadComments"
        [url]='EndpointDictionary.WorkOrder.COMMENTS.TABLE'
        [params]="paramsComments"
        (delete)="deleteComments($event)"
        (add)="addComments($event)"
        (edit)="editComments($event)"
        (fileIconClick)="onFileIconClick($event)"
      >
      </data-table>
    </mat-card>
  </ng-template>
</app-carousel>

<ng-container  *ngTemplateOutlet="buttons"></ng-container>

<ng-template #matDescriptionContent>

  <mat-card class="mat-card-c" [style]="viewCarousel ? 'height: 70vh' : ''">
    <div *ngIf="commentButton" class="comment-btn-top-right">
      <button color="primary" mat-icon-button mat-raised-button
        (click)="addComment.emit(bodyOrder)"
        matTooltip="Agregar comentario">
        <i class="fa fa-comments"></i>
      </button>
    </div>
    
    <h2 [style]="commentButton ? 'width: 90%' : ''"><strong>{{titleNotification}}: {{bodyOrder.code}}</strong></h2>
    <h3>Número de orden: {{bodyOrder.consecutive}}</h3>
    <h3>Tipo de Mantenimiento: {{bodyOrder.maintenanceType}}</h3>
    <h3 *ngIf="showMantenanceType">Tipo de Mantenimiento: {{bodyOrder.maintenanceType}}</h3>
    <h3>Descripción: {{bodyOrder.description}}</h3>
    <h3>Responsable: {{bodyOrder.responsible}}</h3>
    <h3>Fecha ejecución: {{bodyOrder.executionDate}}</h3>
    <h3 *ngIf="!inventoryModule">Recursos: {{bodyOrder.resources}}</h3>
    <h3 *ngIf="showCost">Costo Mantenimiento: {{bodyOrder.cost | number:'1.0-0'}}</h3>
    <h3 *ngIf="inventoryModule">Costo Recursos: {{totalCostItems | number:'1.0-0'}}</h3>
    <h3 *ngIf="bodyOrder.odometer">Odómetro/Horómetro: {{bodyOrder.odometer | number:'1.0-0'}}</h3>
    <hr>
     <div *ngIf="showResponsibles">
      <h3><strong>Quién realiza el mantenimiento</strong></h3>
      <div *ngFor="let item of bodyUser">
        <h3>Encargado: {{item.name}}</h3>
      </div>
    </div>
    <h5>{{note}}</h5>    
  </mat-card>
</ng-template>

<ng-template #buttons>
  <div  class="button" style="justify-content: center;">
    <button *ngIf="closeButton" color="primary" class="button-save mat-elevation-z5" mat-raised-button
      (click)="closeOrder.emit()">Cerrar Orden de trabajo</button>

    <button *ngIf="packOffButton" style="width: 65%;" color="primary" class="button-save mat-elevation-z5" mat-raised-button
      (click)="dispatchResources()">Despachar Recursos</button>
  </div>  

  <div *ngIf="declineButton" class="button" style="justify-content: space-between;">
    <button style="width: 45%;" color="warn" class="button-save mat-elevation-z5" mat-raised-button
      (click)="responseAutorization.emit([false, bodyOrder, bodyUser, resources, inventoryModule])">Rechazar</button>
    <button *ngIf="acceptButton" style="width: 45%;" color="primary" class="button-save mat-elevation-z5"
      mat-raised-button (click)="responseAutorization.emit([true, bodyOrder, bodyUser, resources, inventoryModule])">Autorizar</button>
  </div>
</ng-template>